//= include bootstrap/transition.js
//= include bootstrap/alert.js
//= include bootstrap/button.js
//= include bootstrap/carousel.js
//= include bootstrap/collapse.js
//= include bootstrap/dropdown.js
//= include bootstrap/modal.js
//= include bootstrap/tooltip.js
//= include bootstrap/popover.js
//= include bootstrap/scrollspy.js
//= include bootstrap/tab.js
//= include bootstrap/affix.js